import React, { Component } from 'react'
import { connect } from 'react-redux'
import { Modal } from '@tribal/vw-ngw-ui-library'
import * as pageActions from 'form/store/page/actions'

import {
  Breakpoints,
  Container,
  ContainerPadding,
  ContainerWrap,
  Text,
  TextAppearance,
  ContainerGutter,
  ContainerHorizontalAlignment,
  TextAlignment,
  TextColor,
  ButtonLink,
  ButtonAppearance
} from '@volkswagen-onehub/components-core'

import * as formActions from 'form/store/form/actions'

class ModalOverlay extends Component {
  handleClick = () => {
    const { ShowForm } = this.props
    ShowForm()
  }
  render() {
    const { header, description, ctaText, isOpen } = this.props
    return (
      <Modal isOpen={isOpen} canScroll handleClick={this.handleClick}>
        <Container
          padding={{
            top: {
              [Breakpoints.default]: ContainerPadding.static400,
              [Breakpoints.tablet]: ContainerPadding.static550
            },
            bottom: {
              [Breakpoints.default]: ContainerPadding.static400,
              [Breakpoints.tablet]: ContainerPadding.static550
            },
            left: {
              [Breakpoints.default]: ContainerPadding.static400,
              [Breakpoints.tablet]: ContainerPadding.static750
            },
            right: {
              [Breakpoints.default]: ContainerPadding.static400,
              [Breakpoints.tablet]: ContainerPadding.static750
            }
          }}
          wrap={ContainerWrap.always}
          horizontalAlign={ContainerHorizontalAlignment.center}
          gutter={{
            [Breakpoints.default]: ContainerGutter.static350,
            [Breakpoints.tablet]: ContainerGutter.static450
          }}
        >
          <Text
            tag="h1"
            appearance={TextAppearance.headline350}
            textAlign={TextAlignment.center}
          >
            {header}
          </Text>

          <Text
            tag="p"
            appearance={TextAppearance.copy200}
            textAlign={TextAlignment.left}
          >
            {description}
          </Text>
          <Container horizontalAlign={ContainerHorizontalAlignment.center}>
            <ButtonLink
              appearance={ButtonAppearance.Primary}
              onClick={this.handleClick}
            >
              <Text
                color={TextColor.inherit}
                appearance={TextAppearance.copy150}
              >
                {ctaText}
              </Text>
            </ButtonLink>
          </Container>
        </Container>
      </Modal>
    )
  }
}
const mapStateToProps = ({ page }) => {
  const { cmsdata } = page
  const { errorModal } = cmsdata.data.pages.homePage
  const { header, description, ctaText } = errorModal

  return {
    header,
    description,
    ctaText
  }
}

export default connect(mapStateToProps, { ...formActions, pageActions })(
  ModalOverlay
)
